// Prevents clicking on main links of mobile menu and toggles submenus instead
document.addEventListener('click', function (e) {
  if (window.innerWidth > 1199) return;

  const link = e.target.closest('.wp-block-navigation-submenu > a');
  if (!link) return;

  e.preventDefault();
  e.stopImmediatePropagation();

  const item = link.closest('.wp-block-navigation-submenu');
  const isOpen = item.classList.contains('is-open');

  // Close all siblings at same level
  item.parentElement
    .querySelectorAll(':scope > .wp-block-navigation-submenu')
    .forEach(el => el.classList.remove('is-open'));

  // Toggle current
  if (!isOpen) {
    item.classList.add('is-open');
  }
}, true);

const MOBILE_MENU_ICON_CLASS_BY_LABEL = {
  'get involved': 'mobile-menu-icon--get-involved',
  'our impact': 'mobile-menu-icon--our-impact',
  'our mission': 'mobile-menu-icon--our-mission',
  'our programs': 'mobile-menu-icon--our-programs'
};

const MOBILE_MENU_ICON_CLASSES = Object.values(MOBILE_MENU_ICON_CLASS_BY_LABEL);

function normalizeLabel(text) {
  return text.replace(/\s+/g, ' ').trim().toLowerCase();
}

function addMobileMenuIcons() {
  const menuContainer = document.querySelector('.wp-block-navigation__responsive-container-content');
  if (!menuContainer) return;

  if (window.innerWidth > 1199) {
    menuContainer.querySelectorAll('a.has-mobile-menu-icon').forEach((link) => {
      link.classList.remove('has-mobile-menu-icon');
      MOBILE_MENU_ICON_CLASSES.forEach((iconClass) => link.classList.remove(iconClass));
    });
    return;
  }

  menuContainer.querySelectorAll('a').forEach((link) => {
    const label = (link.textContent || '').replace(/\s+/g, ' ').trim();
    const iconClass = MOBILE_MENU_ICON_CLASS_BY_LABEL[normalizeLabel(label)];

    MOBILE_MENU_ICON_CLASSES.forEach((className) => link.classList.remove(className));
    if (!iconClass) {
      link.classList.remove('has-mobile-menu-icon');
      return;
    }

    link.classList.add('has-mobile-menu-icon');
    link.classList.add(iconClass);
  });
}

const container = document.querySelector('.wp-block-navigation__responsive-container-content');
if (container) {
  const donateButton = document.createElement('button');
  donateButton.innerText = 'Donate';
  donateButton.className = 'mobile-donate-button';


  donateButton.onclick = () => {
    window.location.href = '/donate';
  };

  container.appendChild(donateButton);
}

addMobileMenuIcons();

document.querySelectorAll('.wp-block-navigation__responsive-container-open').forEach((openButton) => {
  openButton.addEventListener('click', function () {
    setTimeout(addMobileMenuIcons, 0);
  });
});

window.addEventListener('resize', addMobileMenuIcons);
